import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Collapse, Row } from "reactstrap";
import { Badge, Box, Container, Flex, Group, Image, Text, Title } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { motion } from "motion/react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { GreenWaves } from "@/components/GreenWaves";
import { ImageContainer, ThemedTitle, TitleContainer } from "@/components/HeaderContainer";

import { useAuth } from "hooks/selectors/useAuth";

import generalApi from "@/services/general-api";

import { ReactComponent as MutlipleLearnersSvg } from "@/assets/img/Course/multiple-users-silhouette.svg";
import { ReactComponent as DurationIcon } from "@/assets/img/Course/upcoming/duration-green.svg";

import { PrintCourseDate } from "../../../../common_function/function";
import CourseInfo from "../../../../components/LearnerPortal/CourseInfo";

function CourserunDetail() {
	let navigate = useNavigate();
	const [message, setmessage] = useState("");
	const MySwal = withReactContent(Swal);
	const [accordionOpen, setAccordionOpen] = useState(false);
	// const [course, setCourse] = useState([]);
	// const [status, setStatus] = useState("");

	// const params = useParams();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const learnerId = queryParams.get("learner_id");
	const authData = useAuth();
	const userData = authData.userData.user;

	const toggleAccordion = () => {
		setAccordionOpen(!accordionOpen);
	};

	let course = {};
	let status = "";
	let course_query;

	if (learnerId) {
		// console.log(course_query.data);
		course_query = useQuery(["upcoming-course", learnerId], () => {
			return generalApi.getUpcomingCourseById(learnerId);
		});

		if (!course_query?.data && course_query.isSuccess) {
			navigate("/course");
		}
		if (course_query?.data) {
			course = course_query.data;
			status = "upcoming";
			// setCourse(course_query.data);
			// setStatus("pending");
		}
	} else {
		const location_data = location.state?.data ?? {};
		const location_status = location.state?.status ?? "";
		if (!Object.keys(location_data).length) {
			navigate("/course");
		}
		// setCourse(location_data);
		// setStatus(location_status);

		course = location_data;
		status = location_status;
	}

	const handleSFCClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
		const data = {};
		const reschedule_to = course.reschedule_to;

		data.callback_url = process.env.REACT_APP_WEB_URL + "/course";
		data.course_id = reschedule_to.course.course_ref;
		data.course_fee = course.learner_sfc;
		data.courserun_id = reschedule_to.courserun_apicourserunid;
		data.courserun_start_date = reschedule_to.courserun_course_from;
		data.nric = userData.learnermaster_nric;
		data.email = userData.learnermaster_email;
		data.mobile = userData.learnermaster_mobile;
		data.tms_regform_id = course.registrationform_id_encrypt;
		data.tms_course_id = reschedule_to.courserun_course_id;
		data.tms_courserun_id = reschedule_to.courserun_id;
		data.tms_learner_id = course.learner_id;
		data.tms_learnermaster_id = userData.learnermaster_id;
		data.purpose = "Reschedule";

		// console.log(data);
		const json_str = btoa(JSON.stringify(data));
		// console.log(json_str);
		// setLoading(true);
		// GTMCheckoutYesSFCButton(checkoutAnalyticsData, userData);
		window.location.href = process.env.REACT_APP_API_URL + "/api/sfc_pay?encoded=" + json_str;
	};

	const handlePopup = (displayMSG) => {
		MySwal.fire({
			title: "Unable to Proceed!",
			html: displayMSG,
			icon: "error",
			// icon: "warning",
			// didOpen: () => {
			// 	// `MySwal` is a subclass of `Swal` with all the same instance & static methods
			// 	MySwal.showLoading();
			// },
		});
	};

	return (
		<Box pb={100}>
			<TitleContainer>Courses</TitleContainer>
			<CourseImageContainer courserunData={course} />
			<TitleContainer>Course Details</TitleContainer>
			<Box bg="white" style={{ borderTop: "2px solid rgba(0, 0, 0, 0.05)" }}>
				<Container px={0}>
					{Object.keys(course).length !== 0 && (
						<>
							{course.attendance_status != "Pending Assessment" ? (
								<>
									<CourseInfo
										course_title={course.course.course_title}
										course_logos={course.course.logos}
										trainer_name={course.trainer?.trainer_name}
										trainer_image_url={course.trainer?.trainer_image_url}
										course_duration={course.duration}
										course_categories={course.course.categories}
										course_ref={course.course.course_ref}
										courserun_modeoftraining={course.courserun_modeoftraining}
										venue_address={course.venue.venue_address}
										training_support_name={course.training_support?.user_name}
										training_support_mobile={course.training_support?.user_mobile}
										courserun_course_from={course.courserun_course_from}
										courserun_course_to={course.courserun_course_to}
										csessions={course.csessions}
										course_description={course.course.course_description}
										course_reschedule_status={course.reschedule_status}
										course_withdrawal_status={course.withdrawal_status}
										course_attendance_status={course.attendance_status}
										tobe_rescheduled={course.tobe_rescheduled}
										claim_id={course.claim_id}
										sfc_claim_id={course.sfc_claim_id}
										claim_status={course.claim_status}
										reschedule_to={course.reschedule_to}
										learner_sfc={course.learner_sfc}
										registrationform_id={course.registrationform_id}
										learner_id={course.learner_id}
										course_banner_image={course.course.course_banner_image}
										pending_assessment_date={
											course.pending_courserun
												? PrintCourseDate(
														course.pending_courserun.courserun_course_from,
														course.pending_courserun.courserun_course_to,
												  )
												: null
										}
										course_short_description={course.course.course_short_description}
										registered_learners={course.registered_learners}
										message={message}
										status={status}
										course={course}
										handlePopup={handlePopup}
										handleSFCClick={handleSFCClick}
										showButtons={true}
									/>
								</>
							) : (
								<>
									<CourseInfo
										course_title={course.pending_courserun.course.course_title}
										course_logos={course.pending_courserun.course.logos}
										trainer_name={course.pending_courserun.trainer?.trainer_name}
										trainer_image_url={course.pending_courserun.trainer?.trainer_image_url}
										course_duration={course.pending_courserun.duration}
										course_categories={course.pending_courserun.course.categories}
										course_ref={course.pending_courserun.course.course_ref}
										courserun_modeoftraining={course.pending_courserun.courserun_modeoftraining}
										venue_address={course.pending_courserun.venue.venue_address}
										training_support_name={course.pending_courserun.training_support?.user_name}
										training_support_mobile={course.pending_courserun.training_support?.user_mobile}
										courserun_course_from={course.pending_courserun.courserun_course_from}
										courserun_course_to={course.pending_courserun.courserun_course_to}
										csessions={course.pending_courserun.csessions}
										course_description={course.pending_courserun.course.course_description}
										course_reschedule_status={course.pending_courserun.reschedule_status}
										course_withdrawal_status={course.pending_courserun.withdrawal_status}
										course_attendance_status={course.attendance_status}
										tobe_rescheduled={course.tobe_rescheduled}
										claim_id={course.claim_id}
										sfc_claim_id={course.sfc_claim_id}
										claim_status={course.claim_status}
										reschedule_to={course.reschedule_to}
										learner_sfc={course.learner_sfc}
										registrationform_id={course.registrationform_id}
										learner_id={course.learner_id}
										course_banner_image={course.course.course_banner_image}
										pending_assessment_date={
											course.pending_courserun
												? PrintCourseDate(
														course.pending_courserun.courserun_course_from,
														course.pending_courserun.courserun_course_to,
												  )
												: null
										}
										course_short_description={course.course.course_short_description}
										registered_learners={course.registered_learners}
										message={message}
										status={status}
										course={course}
										handlePopup={handlePopup}
										handleSFCClick={handleSFCClick}
										showButtons={false}
									/>
									<Card>
										<CardHeader onClick={toggleAccordion} className="cursor-pointer">
											<Row>
												<Col className="col-auto">
													<b>Original Course</b>
												</Col>
												<Col className="col-auto ml-auto">
													{accordionOpen ? (
														<i className="fa fa-times"></i>
													) : (
														<i className="fa fa-plus"></i>
													)}
												</Col>
											</Row>
										</CardHeader>
										<Collapse isOpen={accordionOpen}>
											<CardBody>
												<CourseInfo
													course_title={course.course.course_title}
													course_logos={course.course.logos}
													trainer_name={course.trainer?.trainer_name}
													trainer_image_url={course.trainer?.trainer_image_url}
													course_duration={course.duration}
													course_categories={course.course.categories}
													course_ref={course.course.course_ref}
													courserun_modeoftraining={course.courserun_modeoftraining}
													venue_address={course.venue.venue_address}
													training_support_name={course.training_support?.user_name}
													training_support_mobile={course.training_support?.user_mobile}
													courserun_course_from={course.courserun_course_from}
													courserun_course_to={course.courserun_course_to}
													csessions={course.csessions}
													course_description={course.course.course_description}
													course_reschedule_status={course.reschedule_status}
													course_withdrawal_status={course.withdrawal_status}
													tobe_rescheduled={course.tobe_rescheduled}
													claim_id={course.claim_id}
													sfc_claim_id={course.sfc_claim_id}
													claim_status={course.claim_status}
													reschedule_to={course.reschedule_to}
													learner_sfc={course.learner_sfc}
													registrationform_id={course.registrationform_id}
													learner_id={course.learner_id}
													course_banner_image={course.course.course_banner_image}
													pending_assessment_date={
														course.pending_courserun
															? PrintCourseDate(
																	course.pending_courserun.courserun_course_from,
																	course.pending_courserun.courserun_course_to,
															  )
															: null
													}
													course_short_description={course.course.course_short_description}
													registered_learners={course.registered_learners}
													message={message}
													status={status}
													course={course}
													handlePopup={handlePopup}
													handleSFCClick={handleSFCClick}
													showButtons={false}
												/>
											</CardBody>
										</Collapse>
									</Card>

									<Row className="pt-4 pb-6">
										<Col xl="auto" className="ml-auto">
											{" "}
											<div className="btn-wrap">
												<Link to="/course" className="btn btn-default">
													Back
												</Link>
											</div>
										</Col>
									</Row>
								</>
							)}
						</>
					)}
				</Container>
			</Box>

			{/* <div className='upcoming-course-info-container fadeInDiv'></div> */}
		</Box>
	);
}

const CourseImageContainer = ({ courserunData }) => {
	if (!courserunData.course.details_background_image) {
		return <ImageContainer imageUrl={courserunData.course_banner_image} mih={400} />;
	}

	return (
		<Box
			mih={400}
			pos="relative"
			style={{
				backgroundImage: `url("${courserunData.course.details_background_image}")`,
				backgroundPosition: "right top",
				backgroundSize: "cover",
				backgroundRepeat: "no-repeat",
			}}>
			<GreenWaves w="max(50vw, 700px)" />
			<Container py={20}>
				<Flex justify="space-between" align="center">
					<Box w={{ base: "100%", sm: "60%" }} px={{ base: 0, md: 0 }}>
						<Badge
							color="themed.8"
							leftSection={<DurationIcon width={17} height={17} color="white" />}
							size="lg"
							tt="none">
							<Text size="sm" fw={600}>
								{parseFloat(courserunData.duration).toString()} Days
							</Text>
						</Badge>
						<ThemedTitle order={2}>
							{courserunData.course.course_title}
							{courserunData.course.detail_background_image}
						</ThemedTitle>
						<Text size={"md"} lh={1.3} mt={15}>
							{courserunData.course.course_description}
						</Text>
						<Group gap={10} i mt={10}>
							<MutlipleLearnersSvg width={20} height={20} color="var(--mantine-color-themed-8)" />
							<Text c="themed.8" fw={700} size={"md"} lh={1.3}>
								{courserunData.registered_learners} Learners Registered
							</Text>
						</Group>
					</Box>
					<Box visibleFrom="sm" w={{ base: "100%", sm: "40%" }} px={{ base: 0, md: 0 }}>
						<motion.div
							initial={{ opacity: 0.2, scale: 0.8 }}
							animate={{ opacity: 1, scale: 1 }}
							transition={{ duration: 0.5 }}>
							<Image src={courserunData.course.details_image} />
						</motion.div>
					</Box>
				</Flex>
			</Container>
		</Box>
	);
};

export default CourserunDetail;
